import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Suspense as _Suspense, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5440fe4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "router-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Suspense Loading...", -1))

import { MainHeader } from '@/widgets/MainHeader'
import { MainFooter } from '@/widgets/MainFooter'
import YandexMetrika from './telemetry/YandexMetrika.vue'
import { onBeforeMount, onMounted } from 'vue'
import { actions } from '@/app/providers/store/initLists'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'
import { serverConfig } from '@/shared/config/serverConfig/serverConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { state, dispatch } = useAppStore()

onBeforeMount(async () => {
	actions.onBeforeMount.forEach(actionName => {
		dispatch(actionName)
	})
})

onMounted(() => {
	actions.onMounted.forEach(actionName => {
		dispatch(actionName)
	})

	console.log(serverConfig.value)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_backtop = _resolveComponent("el-backtop")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(YandexMetrika),
    _createVNode(_unref(MainHeader)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      (_openBlock(), _createBlock(_Suspense, null, {
        fallback: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    ])), [
      [
        _directive_loading,
        _unref(state).isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_el_backtop, {
      right: 60,
      bottom: 60
    }),
    _createVNode(_unref(MainFooter))
  ], 64))
}
}

})